import { FilterTypes } from "@/component/FilterCommon/Filter"
import FilterPc from "@/component/Filter/FilterPc"
import React from "react";



export const TestFilterPage  = ()=>{
  const [ values,setValues]= React.useState({})



  return <FilterPc
    values={values}
    onChangeValues={(dataIndex, value)=>{
      console.log(dataIndex, value)
      setValues(values=>{
        return {...values,[dataIndex]:value}
      })
    }}
    filters={[
      { type: FilterTypes.GoodsTags ,dataIndex:"GoodsTags" },
      { type: FilterTypes.DatePick ,dataIndex:"GoodsTags2",showTime:true,showHour:true,showMinute:true},
      { type: FilterTypes.FilterSupplier, dataIndex: 'FilterSupplier', },
      { type: FilterTypes.StaffBranch,dataIndex:"StaffBranch" },
      { type: FilterTypes.SelectGoods, dataIndex:"SelectGoods" },
      { type: FilterTypes.DateUnitPick, dataIndex:'startTestData', dataIndexTwo:'endTestData',picker:'year',value:'202205'},
      { type: FilterTypes.DeliverType, dataIndex: 'DeliverType' },
      { type: FilterTypes.Client, dataIndex: 'Client', },
      // { type: FilterTypes.Coupon, dataIndex: 'Coupon' },
      { type: FilterTypes.Promotion, dataIndex: 'Promotion'}
      // { type: FilterTypes.GoodsPromotion, dataIndex: 'Promotion'}
    ]}
  />
}